// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"124":"40b3187e","518":"7ce9fca7","976":"42e149e0","999":"2c42e62d"}[chunkId] + ".chunk.css";
};